<template>
  <div class="interval" :class="`interval-${size}`">
    <el-input
      class="interval-input margin-l-10"
      v-model.trim="formData.start.value"
      :size="size"
      min="0"
      οnkeyup="value=value.replace(/[^\d]/g,' ')"
      @input="startInput"
      @clear="startClear"
    />
    <div class="interval-middle">-</div>
    <el-input
      class="interval-input margin-r-10"
      v-model.trim="formData.end.value"
      :size="size"
      min="0"
      @input="endInput"
      @clear="endClear"
    />
    <div class="interval-unit">{{ formData.unit }}</div>
  </div>
</template>

<script>
export default {
  name: 'nf-interval',
  props: {
    storeModelName: {
      type: String,
      required: true,
      default: '',
    },
    formData: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    value: {
      type: String,
      default: '',
    },
    // 输入框尺寸  默认 small  medium/small/mini
    size: {
      type: String,
      default: 'mini',
    },
    // 是否清空选项 默认false
    clearable: {
      type: Boolean,
      default: false,
    },
    // 占位符
    placeholder: {
      type: String,
      default: '',
    },
  },
  methods: {
    startInput(val) {
      if (val.length > 0) {
        if (val > this.formData.max) {
          this.formData.start.value = this.formData.max;
          val = this.formData.max;
        }

        this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
          index: this.index,
          value: {
            type: 'start',
            value: this.clearNoNum(val),
          },
        });
      }
    },
    endInput(val) {
      if (val.length > 0) {
        if (val > this.formData.max) {
          this.formData.end.value = this.formData.max;
          val = this.formData.max;
        }
        this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
          index: this.index,
          value: {
            type: 'end',
            value: this.clearNoNum(val),
          },
        });
      }
    },
    startClear() {
      this.value = '';
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: {
          type: 'start',
          value: 0,
        },
      });
    },
    endClear() {
      this.value = '';
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: {
          type: 'end',
          value: '',
        },
      });
    },
    clearNoNum(obj) {
      obj = obj.toString();
      obj = obj.replace(/[^\d.]/g, ''); //清除“数字”和“.”以外的字符
      obj = obj.replace(/\.{2,}/g, '.'); //只保留第一个. 清除多余的
      obj = obj.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
      if (obj.indexOf('.') < 0 && obj != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        obj = parseFloat(obj);
      }
      return obj;
    },
  },
};
</script>

<style scoped lang="scss">
.interval {
  display: flex;
  background: #ffffff;
  border-radius: 3px;
  border: 1px solid #eaebef;
  overflow: hidden;
  margin: 4px auto;
  height: 30px;

  .interval-input {
    margin-top: -4px;
    width: 60px;

    ::v-deep .el-input__inner {
      border: 0;
      padding: 0;
      text-align: center;
    }
  }

  .interval-middle {
    width: 14px;
    line-height: 30px;
    color: #181818;
  }

  .interval-unit {
    width: 48px;
    height: 30px;
    background: #f4f7fa;
    border-radius: 0 2px 2px 0;
    border: 1px solid #eaebef;
    line-height: 30px;
    margin-right: -1px;
    margin-top: -1px;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #919398;
  }
}
</style>
